(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["krosno-delivery-promise"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('krosno-delivery-promise')) return;

    var DAY = 86400000;

    var COPY = {
      pl: {
        orderWithin: 'zamów w ciągu',
        shipsOn: 'wysyłka',
        tomorrow: 'jutro',
        hour: 'godz.',
        minute: 'min',
        second: 's',
        closedPrefix: 'Nie pracujemy',
        weekdayIn: {
          1: 'w poniedziałek',
          2: 'we wtorek',
          3: 'w środę',
          4: 'w czwartek',
          5: 'w piątek',
          6: 'w sobotę',
          7: 'w niedzielę'
        },
        weekdayShort: { 1: 'pon.', 2: 'wt.', 3: 'śr.', 4: 'czw.', 5: 'pt.', 6: 'sob.', 7: 'niedz.' },
        months: [
          'stycznia', 'lutego', 'marca', 'kwietnia', 'maja', 'czerwca',
          'lipca', 'sierpnia', 'września', 'października', 'listopada', 'grudnia'
        ],
        srToday: function (time, range) {
          return 'Zamówienia złożone dziś do godziny ' + time +
            ' wysyłamy tego samego dnia roboczego. Przewidywana dostawa: ' + range + '.';
        },
        srNext: function (day, range) {
          return 'Najbliższa wysyłka ' + day + '. Przewidywana dostawa: ' + range + '.';
        }
      },
      en: {
        orderWithin: 'order within',
        shipsOn: 'ships',
        tomorrow: 'tomorrow',
        hour: 'hr',
        minute: 'min',
        second: 's',
        closedPrefix: 'Closed',
        weekdayIn: {
          1: 'on Monday',
          2: 'on Tuesday',
          3: 'on Wednesday',
          4: 'on Thursday',
          5: 'on Friday',
          6: 'on Saturday',
          7: 'on Sunday'
        },
        weekdayShort: { 1: 'Mon', 2: 'Tue', 3: 'Wed', 4: 'Thu', 5: 'Fri', 6: 'Sat', 7: 'Sun' },
        months: [
          'January', 'February', 'March', 'April', 'May', 'June',
          'July', 'August', 'September', 'October', 'November', 'December'
        ],
        srToday: function (time, range) {
          return 'Orders placed today before ' + time +
            ' ship the same business day. Estimated delivery: ' + range + '.';
        },
        srNext: function (day, range) {
          return 'Next dispatch ' + day + '. Estimated delivery: ' + range + '.';
        }
      }
    };

    var HOLIDAY_NAMES = {
      pl: {
        newYear: 'Nowy Rok',
        epiphany: 'Trzech Króli',
        easterMonday: 'Poniedziałek Wielkanocny',
        labour: 'Święto Pracy',
        constitution: 'Święto Konstytucji 3 Maja',
        pentecost: 'Zielone Świątki',
        corpusChristi: 'Boże Ciało',
        assumption: 'Wniebowzięcie NMP',
        allSaints: 'Wszystkich Świętych',
        independence: 'Narodowe Święto Niepodległości',
        christmasEve: 'Wigilia Bożego Narodzenia',
        christmas: 'Boże Narodzenie',
        boxingDay: 'drugi dzień Bożego Narodzenia'
      },
      en: {
        newYear: "New Year's Day",
        epiphany: 'Epiphany',
        easterMonday: 'Easter Monday',
        labour: 'Labour Day',
        constitution: 'Constitution Day',
        pentecost: 'Whit Sunday',
        corpusChristi: 'Corpus Christi',
        assumption: 'Assumption Day',
        allSaints: "All Saints' Day",
        independence: 'Independence Day',
        christmasEve: 'Christmas Eve',
        christmas: 'Christmas Day',
        boxingDay: 'Boxing Day'
      }
    };

    var holidayCache = {};

    /* Algorytm anonimowy gregoriański (Meeus/Jones/Butcher) */
    function easterSunday(year) {
      var a = year % 19;
      var b = Math.floor(year / 100);
      var c = year % 100;
      var d = Math.floor(b / 4);
      var e = b % 4;
      var f = Math.floor((b + 8) / 25);
      var g = Math.floor((b - f + 1) / 3);
      var h = (19 * a + b - d - g + 15) % 30;
      var i = Math.floor(c / 4);
      var k = c % 4;
      var l = (32 + 2 * e + 2 * i - h - k) % 7;
      var m = Math.floor((a + 11 * h + 22 * l) / 451);
      var month = Math.floor((h + l - 7 * m + 114) / 31);
      var day = ((h + l - 7 * m + 114) % 31) + 1;
      return Date.UTC(year, month - 1, day);
    }

    function key(ms) {
      var d = new Date(ms);
      var m = d.getUTCMonth() + 1;
      var day = d.getUTCDate();
      return d.getUTCFullYear() + '-' + (m < 10 ? '0' + m : m) + '-' + (day < 10 ? '0' + day : day);
    }

    function holidays(year) {
      if (holidayCache[year]) return holidayCache[year];
      var map = {};
      map[key(Date.UTC(year, 0, 1))] = 'newYear';
      map[key(Date.UTC(year, 0, 6))] = 'epiphany';
      map[key(Date.UTC(year, 4, 1))] = 'labour';
      map[key(Date.UTC(year, 4, 3))] = 'constitution';
      map[key(Date.UTC(year, 7, 15))] = 'assumption';
      map[key(Date.UTC(year, 10, 1))] = 'allSaints';
      map[key(Date.UTC(year, 10, 11))] = 'independence';
      map[key(Date.UTC(year, 11, 25))] = 'christmas';
      map[key(Date.UTC(year, 11, 26))] = 'boxingDay';
      /* Wigilia jest dniem ustawowo wolnym od 2025 r. */
      if (year >= 2025) map[key(Date.UTC(year, 11, 24))] = 'christmasEve';

      var easter = easterSunday(year);
      map[key(easter + DAY)] = 'easterMonday';
      map[key(easter + 49 * DAY)] = 'pentecost';
      map[key(easter + 60 * DAY)] = 'corpusChristi';

      holidayCache[year] = map;
      return map;
    }

    function isoDay(ms) {
      var d = new Date(ms).getUTCDay();
      return d === 0 ? 7 : d;
    }

    function parseDays(value, fallback) {
      var out = {};
      var source = (value || '').split(',');
      var any = false;
      for (var i = 0; i < source.length; i++) {
        var n = parseInt(source[i], 10);
        if (n >= 1 && n <= 7) {
          out[n] = true;
          any = true;
        }
      }
      if (!any) {
        for (var j = 0; j < fallback.length; j++) out[fallback[j]] = true;
      }
      return out;
    }

    class KrosnoDeliveryPromise extends HTMLElement {}

    var proto = KrosnoDeliveryPromise.prototype;

    proto.connectedCallback = function () {
      var cutoff = (this.dataset.cutoff || '15:00').split(':');
      this.cfg = {
        tz: this.dataset.timezone || 'Europe/Warsaw',
        lang: COPY[this.dataset.lang] ? this.dataset.lang : 'pl',
        cutoffH: parseInt(cutoff[0], 10) || 0,
        cutoffM: parseInt(cutoff[1], 10) || 0,
        transitMin: Math.max(0, parseInt(this.dataset.transitMin, 10) || 0),
        transitMax: Math.max(0, parseInt(this.dataset.transitMax, 10) || 0),
        shipDays: parseDays(this.dataset.shipDays, [1, 2, 3, 4, 5]),
        deliveryDays: parseDays(this.dataset.deliveryDays, [1, 2, 3, 4, 5]),
        closed: {}
      };

      var extra = (this.dataset.closedDays || '').split(',');
      for (var i = 0; i < extra.length; i++) {
        var day = extra[i].trim();
        if (day) this.cfg.closed[day] = true;
      }

      try {
        this.fmt = new Intl.DateTimeFormat('en-GB', {
          timeZone: this.cfg.tz,
          year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', second: '2-digit',
          hourCycle: 'h23'
        });
      } catch (e) {
        return; /* Nieznana strefa — zostaje komunikat zastępczy z Liquida */
      }

      this.nodes = {
        date: this.querySelector('[data-kdp-date]'),
        cut: this.querySelector('[data-kdp-cut]'),
        note: this.querySelector('[data-kdp-note]'),
        sr: this.querySelector('[data-kdp-sr]')
      };
      if (!this.nodes.date || !this.nodes.cut) return;

      this.initTooltip();

      this.onVisibility = this.handleVisibility.bind(this);
      document.addEventListener('visibilitychange', this.onVisibility);

      if (typeof IntersectionObserver === 'function') {
        this.observer = new IntersectionObserver(
          function (entries) {
            this.inView = entries[0].isIntersecting;
            this.syncTimer();
          }.bind(this),
          { rootMargin: '120px' }
        );
        this.observer.observe(this);
      } else {
        this.inView = true;
      }

      this.update();
      this.syncTimer();
    };

    proto.disconnectedCallback = function () {
      this.stopTimer();
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
      if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
      if (this.onDocClick) document.removeEventListener('click', this.onDocClick);
      if (this.onKey) document.removeEventListener('keydown', this.onKey);
    };

    proto.initTooltip = function () {
      var btn = this.querySelector('.kdp__tip-btn');
      var panel = this.querySelector('.kdp__tip-panel');
      if (!btn || !panel) return;

      var close = function () {
        panel.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
      };

      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var open = panel.hidden;
        panel.hidden = !open;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });

      this.onDocClick = function (event) {
        if (!panel.hidden && !this.contains(event.target)) close();
      }.bind(this);
      this.onKey = function (event) {
        if (event.key === 'Escape' && !panel.hidden) {
          close();
          btn.focus();
        }
      };
      document.addEventListener('click', this.onDocClick);
      document.addEventListener('keydown', this.onKey);
    };

    proto.handleVisibility = function () {
      if (!document.hidden) this.update();
      this.syncTimer();
    };

    proto.syncTimer = function () {
      var wanted = this.inView !== false && !document.hidden;
      if (wanted && !this.timer) {
        this.timer = setInterval(this.update.bind(this), 1000);
      } else if (!wanted) {
        this.stopTimer();
      }
    };

    proto.stopTimer = function () {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    };

    /* Bieżący czas sklepu jako data cywilna — odporny na strefę urządzenia i DST */
    proto.shopNow = function () {
      var parts = this.fmt.formatToParts(new Date());
      var p = {};
      for (var i = 0; i < parts.length; i++) {
        if (parts[i].type !== 'literal') p[parts[i].type] = parts[i].value;
      }
      return {
        ms: Date.UTC(+p.year, +p.month - 1, +p.day),
        h: +p.hour,
        mi: +p.minute,
        s: +p.second
      };
    };

    proto.isClosed = function (ms) {
      var k = key(ms);
      if (this.cfg.closed[k]) return 'custom';
      var name = holidays(new Date(ms).getUTCFullYear())[k];
      return name || null;
    };

    proto.isOpen = function (ms, days) {
      return !!days[isoDay(ms)] && !this.isClosed(ms);
    };

    proto.nextOpen = function (ms, days) {
      var cursor = ms;
      for (var i = 0; i < 400; i++) {
        cursor += DAY;
        if (this.isOpen(cursor, days)) return cursor;
      }
      return cursor;
    };

    proto.addBusinessDays = function (ms, count, days) {
      var cursor = ms;
      var added = 0;
      var guard = 0;
      while (added < count && guard++ < 400) {
        cursor += DAY;
        if (this.isOpen(cursor, days)) added++;
      }
      return cursor;
    };

    proto.formatDate = function (ms, copy) {
      var d = new Date(ms);
      return d.getUTCDate() + ' ' + copy.months[d.getUTCMonth()];
    };

    /* Zawsze skrót dnia tygodnia — bez odmiany, bo data stoi po dwukropku */
    proto.formatRange = function (fromMs, toMs, copy) {
      var from = new Date(fromMs);
      var to = new Date(toMs);
      var wdFrom = copy.weekdayShort[isoDay(fromMs)];
      var wdTo = copy.weekdayShort[isoDay(toMs)];

      if (fromMs === toMs) {
        return wdFrom + ', ' + this.formatDate(fromMs, copy);
      }
      if (from.getUTCMonth() === to.getUTCMonth()) {
        return wdFrom + '–' + wdTo + ', ' + from.getUTCDate() + '–' + to.getUTCDate() +
          ' ' + copy.months[to.getUTCMonth()];
      }
      return wdFrom + '–' + wdTo + ', ' + this.formatDate(fromMs, copy) + ' – ' + this.formatDate(toMs, copy);
    };

    /* Bez sekundnika. Zaokraglenie w dol jest celowe: lepiej pokazac mniej czasu
       niz faktycznie zostalo, niz obiecac wiecej i nie dowiezc wysylki tego dnia. */
    proto.countdown = function (totalSeconds, copy) {
      var h = Math.floor(totalSeconds / 3600);
      var m = Math.floor((totalSeconds % 3600) / 60);
      var pad = function (n) { return n < 10 ? '0' + n : String(n); };
      if (h > 0) {
        return h + ' ' + copy.hour + ' ' + pad(m) + ' ' + copy.minute;
      }
      return m + ' ' + copy.minute;
    };

    /* Timer tyka co sekunde, ale napis zmienia sie raz na minute. Bez tej bramki
       przepisywalibysmy DOM 60 razy na minute bez zadnej zmiany na ekranie. */
    proto.write = function (key, node, value, asHtml) {
      if (!node) return;
      var last = this._last || (this._last = {});
      if (last[key] === value) return;
      last[key] = value;
      if (asHtml) node.innerHTML = value;
      else node.textContent = value;
    };

    proto.update = function () {
      var cfg = this.cfg;
      var copy = COPY[cfg.lang];
      var now = this.shopNow();
      var cutoffSeconds = cfg.cutoffH * 3600 + cfg.cutoffM * 60;
      var nowSeconds = now.h * 3600 + now.mi * 60 + now.s;

      var shipsToday = this.isOpen(now.ms, cfg.shipDays) && nowSeconds < cutoffSeconds;
      var shipMs = shipsToday ? now.ms : this.nextOpen(now.ms, cfg.shipDays);

      var fromMs = this.addBusinessDays(shipMs, cfg.transitMin, cfg.deliveryDays);
      var toMs = cfg.transitMax > cfg.transitMin
        ? this.addBusinessDays(shipMs, cfg.transitMax, cfg.deliveryDays)
        : fromMs;

      var range = this.formatRange(fromMs, toMs, copy);
      var remaining = cutoffSeconds - nowSeconds;
      var urgent = shipsToday && remaining <= 3600;

      this.classList.toggle('kdp--urgent', urgent);

      var cutoffLabel = (cfg.cutoffH < 10 ? '0' + cfg.cutoffH : cfg.cutoffH) + ':' +
        (cfg.cutoffM < 10 ? '0' + cfg.cutoffM : cfg.cutoffM);

      this.write('date', this.nodes.date, range);

      if (shipsToday) {
        /* Bez wiodącej spacji — odstęp daje whitespace w markupie przed spanem */
        this.write('cut', this.nodes.cut, '· ' + copy.orderWithin +
          ' <span class="kdp__value">' + this.countdown(remaining, copy) + '</span>', true);
        this.write('sr', this.nodes.sr, copy.srToday(cutoffLabel, range));
      } else {
        var label = shipMs === now.ms + DAY ? copy.tomorrow : copy.weekdayIn[isoDay(shipMs)];
        this.write('cut', this.nodes.cut, '· ' + copy.shipsOn + ' ' + label);
        this.write('sr', this.nodes.sr, copy.srNext(label, range));
      }
      this.nodes.cut.hidden = false;

      this.renderNote(now.ms, toMs, copy);
    };

    /* Jeśli wysyłkę albo dostawę przesuwa dzień ustawowo wolny — powiedz o tym wprost */
    proto.renderNote = function (todayMs, untilMs, copy) {
      var note = this.nodes.note;
      if (!note) return;

      var names = [];
      var dict = HOLIDAY_NAMES[this.cfg.lang];
      for (var cursor = todayMs; cursor <= untilMs; cursor += DAY) {
        var found = this.isClosed(cursor);
        if (found && found !== 'custom' && dict[found]) {
          names.push(this.formatDate(cursor, copy) + ' — ' + dict[found]);
        }
      }

      if (names.length) {
        this.write('note', note, copy.closedPrefix + ': ' + names.join(' · '));
        note.hidden = false;
      } else {
        this.write('note', note, '');
        note.hidden = true;
      }
    };

    customElements.define('krosno-delivery-promise', KrosnoDeliveryPromise);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["krosno-product-card"] && !Shopify.designMode) return;
  try {
    function getKrosnoCardVariants(card) {
    const source = card.querySelector('[data-khp-card-variants]');

    if (!source?.textContent) return [];

    try {
      return JSON.parse(source.textContent);
    } catch (error) {
      console.error('Failed to parse Krosno product card variants', error);
      return [];
    }
  }

  function getKrosnoCardSelectedOptions(card) {
    return Array.from(card.querySelectorAll('[data-khp-variant-option]:checked'))
      .map((input) => ({
        position: Number(input.dataset.optionPosition),
        value: input.value,
      }))
      .filter((option) => option.position > 0)
      .sort((a, b) => a.position - b.position);
  }

  function findKrosnoCardVariant(variants, selectedOptions) {
    return variants.find((variant) =>
      selectedOptions.every((option) => String(variant.options[option.position - 1]) === option.value)
    );
  }

  function updateKrosnoCardImage(card, variant) {
    const image = card.querySelector('.khp-card__media--primary');

    if (!(image instanceof HTMLImageElement) || !variant?.image) return;

    image.src = variant.image.src;
    image.srcset = variant.image.srcset;
    image.alt = variant.image.alt || image.alt;
  }

  function updateKrosnoCardButton(card, variant) {
    const button = card.querySelector('[ref="addToCartButton"]');
    const text = button?.querySelector('.add-to-cart-text__content span span');

    if (!(button instanceof HTMLButtonElement) || !text) return;

    const isAvailable = Boolean(variant?.available);
    button.disabled = !isAvailable;
    text.textContent = variant ? button.dataset.addToCartText || text.textContent : button.dataset.unavailableText || text.textContent;

    if (variant && !isAvailable) {
      text.textContent = button.dataset.soldOutText || text.textContent;
    }

    const buttonContainer = card.querySelector('add-to-cart-component');

    if (buttonContainer instanceof HTMLElement && variant?.image?.src) {
      buttonContainer.dataset.productVariantMedia = `${variant.image.src}&width=100`;
    }
  }

  function updateKrosnoProductCard(card, variant) {
    const variantInput = card.querySelector('input[name="id"]');
    const price = card.querySelector('[data-khp-card-price]');

    if (variantInput instanceof HTMLInputElement) {
      variantInput.value = variant?.id || '';
    }

    if (price && variant?.priceHtml) {
      price.innerHTML = variant.priceHtml;
    }

    if (variant?.url) {
      card.querySelectorAll('[data-khp-card-link]').forEach((link) => {
        if (link instanceof HTMLAnchorElement) {
          link.href = variant.url;
        }
      });
    }

    updateKrosnoCardImage(card, variant);
    updateKrosnoCardButton(card, variant);
  }

  function storeKrosnoCardBreadcrumbSource(link) {
    const card = link.closest('[data-khp-product-card]');

    if (!card?.dataset.khpCardProductId || !card.dataset.khpCardSourceUrl || !card.dataset.khpCardSourceTitle) return;

    try {
      sessionStorage.setItem(
        'krosno:pdp-breadcrumb-source',
        JSON.stringify({
          productId: card.dataset.khpCardProductId,
          title: card.dataset.khpCardSourceTitle,
          url: card.dataset.khpCardSourceUrl,
          savedAt: Date.now(),
        })
      );
    } catch (error) {
      console.error('Failed to store PDP breadcrumb source', error);
    }
  }

  document.addEventListener('click', (event) => {
    const link = event.target?.closest?.('[data-khp-card-link]');

    if (link instanceof HTMLAnchorElement) {
      storeKrosnoCardBreadcrumbSource(link);
    }
  });

  document.addEventListener('change', (event) => {
    const input = event.target?.closest?.('[data-khp-variant-option]');
    const card = input?.closest?.('[data-khp-product-card]');

    if (!input || !card) return;

    const variants = getKrosnoCardVariants(card);
    const selectedOptions = getKrosnoCardSelectedOptions(card);
    const variant = findKrosnoCardVariant(variants, selectedOptions);

    updateKrosnoProductCard(card, variant);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-information-content"] && !Shopify.designMode) return;
  try {
    const breadcrumb = document.querySelector('[data-krosno-pdp-breadcrumb]');

  if (breadcrumb instanceof HTMLAnchorElement) {
    try {
      const source = JSON.parse(sessionStorage.getItem('krosno:pdp-breadcrumb-source') || 'null');
      const maxAge = 2 * 60 * 60 * 1000;
      const productMatches = String(source?.productId || '') === String(breadcrumb.dataset.productId || '');
      const sourceIsFresh = Date.now() - Number(source?.savedAt || 0) < maxAge;

      if (productMatches && sourceIsFresh && source?.url && source?.title) {
        const label = breadcrumb.querySelector('.krosno-product-mobile-breadcrumb__label');

        breadcrumb.href = source.url;
        if (label) label.textContent = String(source.title).toUpperCase();
      }
    } catch (error) {
      console.error('Failed to apply PDP breadcrumb source', error);
    }
  }
  } catch(e) { console.error(e); }
})();

})();
